import React, { PropTypes } from "react";
import classnames from "classnames";

import { monthEdges, weeksOfMonth } from "../dist/dateUtils";
import { getMods, getModsByCompType } from "../dist/util";
import Week from "./Week";

const clsPrefix = "rc-Month";

const Month = (props) => {
  const { date } = props;
  const edges = monthEdges(date);

  let { mods, day, week } = props;
  let clsMods, events;

  if (!props.day) {
    day = getModsByCompType("day", mods);
  }

  if (!props.week) {
    week = getModsByCompType("week", mods);
  }

  if (!props.day || !props.week) {
    // this means we're probably just rendering a single month and need to filter our component types again.
    mods = getModsByCompType("month", mods);
  }

  let fWeekMods = week.filter((mod, j) =>
    mod.date ? mod.date.isSame(date, "month") : true
  );
  let fDayMods = day.filter(
    (mod, k) => {
      if (mod.date) {
       // return mod.date.isSame(date, "month");
       return true;
      }
      return true;
    }
    //mod.date ? mod.date.isSame(date, "month") : true
  );
  const modifiers = getMods(mods, date, clsPrefix, "month");

  if (modifiers) {
    clsMods = modifiers.clsMods;
    events = modifiers.events;
  }

  return (
    <div className={classnames(clsPrefix, clsMods)} {...events}>
      {weeksOfMonth(props.date).map((wDate, i) => (
        <Week
          key={`week-${i}`}
          date={wDate}
          edges={edges}
          mods={fWeekMods}
          day={fDayMods}
        />
      ))}
    </div>
  );
};

Month.propTypes = {
  // monthNames: PropTypes.bool,
  // monthNameFormat: PropTypes.string,
  // weekdayNames: PropTypes.bool,
  // weekdayFormat: PropTypes.string,
  // mod: PropTypes.object
};

Month.defaultProps = {
  monthNames: true,
  monthNameFormat: "MMMM YYYY",
  weekdayNames: true,
  weekdayFormat: "dd",
};

export default Month;
